import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import TkInputWithText from "../../../components/molecules/TkInputWithText";
import "./_style.scss";

/**
 * 被共済職員期間
 * @param {any} props.year 被共済職員期間（年）１
 * @param {any} props.month 被共済職員期間（月）１
 * @param {any} props.onChange Changeイベント
 * @return MaePeriod
 */
export const MaePeriod = (props: any) => {
  const { year, month, onChange, disabled } = props;
  const [yearNew, setYearNew] = useState(year);
  const [monthNew, setMonthNew] = useState(month);

  useEffect(() => {
    onChange && onChange({ year: yearNew, month: monthNew });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, month]);

  return (
    <Box className="SCRC060134Components">
      <Box className="maePeriod">
        <TkInputWithText
          innerText="年"
          wantToSetValue={year}
          onGetInputValue={(value: any) => setYearNew(value)}
          disabled={disabled}
        />
        <TkInputWithText
          innerText="月"
          wantToSetValue={month}
          onGetInputValue={(value: any) => setMonthNew(value)}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};
